import { useMemo } from "react";
import { buildItineraryTableDays } from "../service/itineraryTableService";
import type { ItineraryTableSource } from "../types/itineraryTable";
import { ItineraryMarkdown } from "./ItineraryMarkdown";
import "./itineraryTable.css";

/** 编辑器、独立页和分享页共用每日考察安排及住宿表格。 */
export function ItineraryTablePanel({ editor }: { editor: ItineraryTableSource }) {
  const days = useMemo(() => buildItineraryTableDays(editor), [editor]);
  return <div className="itinerary-table-scroll" tabIndex={0} aria-label="行程表格，可纵向滚动">
    <table className="itinerary-overview-table" aria-label="行程表格">
      <colgroup><col className="itinerary-table-date-col" /><col className="itinerary-table-route-col" /><col className="itinerary-table-slot-col" /><col /><col className="itinerary-table-stay-col" /></colgroup>
      <thead><tr><th scope="col">天数 / 日期</th><th scope="col">线路</th><th scope="col" colSpan={2}>行程安排</th><th scope="col">住宿</th></tr></thead>
      {days.map((day) => <tbody key={day.id}>
        <tr>
          <th scope="rowgroup" rowSpan={day.unfinished ? 1 : day.slots.length} className="itinerary-table-day">
            <strong>D{day.dayNumber}</strong><span>{day.dateLabel}</span>{day.weekday && <span>{day.weekday}</span>}
          </th>
          {day.unfinished ? <td colSpan={4} className="itinerary-table-unfinished">未完成</td> : <>
            <td rowSpan={day.slots.length} className="itinerary-table-route">{day.routeLabel}</td>
            <th scope="row" className="itinerary-table-slot">{day.slots[0].label}</th>
            <td><SlotGroups groups={day.slots[0].groups} /></td>
            <td rowSpan={day.slots.length} className="itinerary-table-stay">{day.stayLabel}</td>
          </>}
        </tr>
        {!day.unfinished && day.slots.slice(1).map((slot, index) => <tr key={`${slot.key}-${index}`}>
          <th scope="row" className="itinerary-table-slot">{slot.label}</th>
          <td><SlotGroups groups={slot.groups} /></td>
        </tr>)}
      </tbody>)}
      {!days.length && <tbody><tr><td colSpan={5} className="itinerary-table-unfinished">请先添加行程天数</td></tr></tbody>}
    </table>
  </div>;
}

/** 分专业显示时段内容，并沿用已有的安全 Markdown 渲染。 */
function SlotGroups({ groups }: { groups: Array<{ label: string; text: string }> }) {
  return groups.map((group, index) => <div className="itinerary-table-slot-content" key={index}>
    {group.label && <strong>{group.label}：</strong>}<ItineraryMarkdown content={group.text} className="itinerary-table-markdown" />
  </div>);
}
